import { Component, OnInit } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { flatMap, map, take } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { LogService } from '../../core/log.service';

@Component({
  selector: 'app-on-sign-up',
  templateUrl: './on-sign-up.component.html',
  styleUrls: ['./on-sign-up.component.scss'],
})
export class OnSignUpComponent {
  public sessionResolved?: Observable<boolean>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private log: LogService,
  ) {}
}
